<template>
  <!--权限管理页面-->
  <div id="authorityList">
    <div class="allTablePlace">
      <div class="authorityBody">
        <div class="authorityleft">
          <nav class="authorityNav">角色列表</nav>
          <div>
            <ul>
              <li @click="selectRoles(index)" v-for="(item, index) in roleMenu" :key="index" :class="selectIndex === index ? 'onClickli' : ''" style="display: flex;justify-content: space-between;">
                <span>{{item.role}}</span>
                <span v-if="item.role !== 'Content Owner' && item.role !== 'Administrator' && item.role !== 'HCP Owner' && item.role !== '自动回复管理员' && item.role !== 'Content Editor' && item.role !== '渠道二维码管理员'">
                  <i @click="updateRole(item)" class="icon iconfont iconbianji font12" :style="selectIndex === index ? 'color:#fff;' : 'color:#ee1100;'"></i>
                  <i @click="deleteRole(item)" class="icon iconfont iconshanchu m_l_10 font12" :style="selectIndex === index ? 'color:#fff;' : 'color:#ee1100;'"></i>
                </span>
              </li>
            </ul>
          </div>
          <div @click="addNewRole" class="addSubmenu m_t_10" style="background-color: #F9FAFB">+添加角色</div>
        </div>
        <!-- <div v-if="selectIndex === 0" class="authorityCentTwo">
          <nav class="authorityNav">用户列表</nav>
          <p class="p_r d_i" style="padding:0 10px">
            <input @input="searchUser" class="allInput menuUserSearch onlyInput" type="text" style="padding: 5px 20px 5px 5px;" placeholder="姓名,工作邮箱">
            <i class="icon iconfont iconsousuo p_a colorRed alldw" style="right: 14px;top:7px;"></i>
          </p>
          <div class="horSpan">
            <span class="userList" :key="index" v-for="(item, index) in userList">{{item.userName}} - {{item.email}}</span>
          </div>
        </div> -->
        <!-- <div v-if="selectIndex === 1 || selectIndex === 2 || selectIndex === 3" class="authorityCent"> -->
        <div style="width: 25%" class="authorityCent">
          <nav class="authorityNav">用户列表</nav>
          <p class="p_r d_i" style="width: calc(100% - 30px);padding:0 10px">
            <input  @input="searchUser" class="allInput menuUserSearch onlyInput" type="text" placeholder="姓名,工作邮箱" style="width:calc(100% - 20px);padding: 5px 20px 5px 5px;">
            <i class="icon iconfont iconsousuo p_a colorRed alldw" style="right: 8px;top:7px;"></i>
          </p>
          <div class="horSpan" style="width: calc(100% - 20px)">
            <span :class="index === userSelectIndex ? 'activeUser' : ''" :key="index" v-for="(item, index) in userList" class="delSpan userList" :title="item.chineseName + ' - '  + item.email">
              <abbr class="NoWrap d_i" style="width: calc(100% - 20px)">{{item.chineseName}} - {{item.email}}</abbr><i @click="removeSelectUser(index)" class="m_l_5 font16 colorCH" style="color:#ee1100">×</i>
            </span>
          </div>
          <div @click="addNewUser" class="addSubmenu m_t_10" style="background-color: #F9FAFB">+添加用户</div>
        </div>
        <!-- <div v-if="selectIndex === 1 || selectIndex === 2 || selectIndex === 3" class="authorityRight"> -->
        <div style="width: 55%" class="authorityRight">
          <div>
            <nav class="authorityNav">权限列表</nav>
            <div class="d_flex" style="padding: 0 10px">
              <!-- <span  v-if="selectIndex === 3"  class="allInformation">分组</span> -->
              <!-- <span  v-if="selectIndex === 2 || selectIndex === 1"  class="allInformation">内容类别</span> -->
              <span class="allInformation">菜单权限</span>
              <div>
                <!-- 暂时隐藏上传按钮，不要删除！ -->
                <!-- <input hidden @change="inportUser($event)" id="userFile" type="file">
                <button class="redButtonTwo">
                  <label for="userFile">L-Takeda</label>
                </button> -->
                <!-- 暂时隐藏上传按钮，不要删除！ -->
                <!-- <input hidden @change="inportUser2($event)" id="userFile2" type="file">
                <button class="redButtonTwo">
                  <label for="userFile2">L-Shire</label>
                </button> -->
                <button v-if="!groupFlag" @click="groupsEditMode" class="redButtonTwo">编辑</button>
                <button v-if="groupFlag" @click="editGroupsConfirm" class="redButtonTwo">保存</button>
                <button v-if="groupFlag" @click="returnEidtFlag(userSelectIndex)" class="cancelButtonTwo">返回</button>
              </div>
            </div>
            <div class="m_t_10" style="padding: 0 10px">
              <table cellspacing="0" class="allTable">
                <thead>
                <tr>
                  <!-- <th v-if="selectIndex === 3">分组名称</th>
                  <th v-if="selectIndex === 3">描述</th>
                  <th v-if="selectIndex === 2 || selectIndex === 1">类别名称</th> -->
                  <th>菜单名称</th>
                  <th></th>
                  <th>二级菜单</th>
                  <th>操作权限</th>
                </tr>
                </thead>
                <tbody>
                <!-- <tr :key="index" v-for="(item, index) in allGroupsList"> -->
                <tr :key="index" v-for="(item, index) in totalmenuList" >
                  <!-- <td v-if="selectIndex === 3">{{item.name}}</td>
                  <td v-if="selectIndex === 3">{{item.description}}</td>
                  <td v-if="selectIndex === 2 || selectIndex === 1">{{item.typeName}}</td> -->
                  <td>{{item.menuName}}</td>
                  <td>
                    <input :disabled="!groupFlag" v-model="item.isSelected" type="checkbox" class="allCheckbox" :id="'Oncheckbox' + index" name="checbox" @change="changeFather(item)"/>
                    <label :for="'Oncheckbox' + index"></label>
                  </td>
                  <td>
                    <ul class="qxUl">
                      <li :key="tabIndex" v-for="(tabItem, tabIndex) in item.tabMenus">
                        <span>{{tabItem.menuName}}</span>
                        <input :disabled="!groupFlag" v-model="tabItem.isSelected" type="checkbox" class="allCheckbox" :id="'OncheckboxTab' + index + tabIndex" name="checbox" @change="checkIfGetAll(item, tabItem)"/>
                        <label :for="'OncheckboxTab' + index + tabIndex"></label>
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul class="qxUl">
                      <li :key="btIndex" v-for="(btItem, btIndex) in item.buttonMenus">
                        <span>{{btItem.menuName}}</span>
                        <input :disabled="!groupFlag" v-model="btItem.isSelected" type="checkbox" class="allCheckbox" :id="'OncheckboxBt' + index + btIndex" name="checbox" @change="clickBt(item, btItem)"/>
                        <label :for="'OncheckboxBt' + index + btIndex"></label>
                      </li>
                    </ul>
                  </td>
                </tr>
                </tbody>
              </table>
              <!-- 菜单权限 树结构 -->
              <!-- <tree :data="totalmenuList" :disabled="!groupFlag"></tree> -->
            </div>
          </div>
          <!--<div style="margin-top: 20px;">-->
          <!--  <div class="d_flex" style="padding: 0 10px">-->
          <!--    <span class="allInformation">操作权限</span>-->
          <!--  </div>-->
          <!--  <div class="m_t_10" style="padding: 0 10px;max-height: 750px;overflow: auto">-->
          <!--    &lt;!&ndash; 操作权限 树结构 &ndash;&gt;-->
          <!--    <tree :data="treeOperationList" :disabled="!groupFlag"></tree>-->
          <!--  </div>-->
          <!--</div>-->
        </div>
        <!-- <div v-if="selectIndex === 4 || selectIndex === 5" class="authorityCentTwo">
          <nav class="authorityNav">用户列表</nav>
          <p class="p_r d_i" style="padding:0 10px">
            <input @input="searchUser" class="allInput menuUserSearch onlyInput" type="text" style="padding: 5px 20px 5px 5px;" placeholder="姓名,工作邮箱">
            <i class="icon iconfont iconsousuo p_a colorRed alldw" style="right: 14px;top:7px;"></i>
          </p>
          <p style="margin-left: 15px" class="d_i">
            <button @click="addNewUser"  class="redButton">添加用户</button>
          </p>
          <div class="horSpan">
            <span class="userList" :key="index" v-for="(item, index) in userList">{{item.userName}} - {{item.email}} <i @click="removeSelectUser(index)" class="m_l_5 font16 colorCH" style="color:#ee1100">×</i></span>
          </div>
        </div> -->
        <userPicker v-on:choosedConfirm="confirUserPicker($event)" v-model="showUserPicker"></userPicker>
      </div>
    </div>
    <!-- 添加角色 -->
    <model v-if="showRoleModal" :buttonType="0" :title="roleModalTitle" :minWidth="'500px'" v-on:on-cancel="cancelRoleModal()" v-on:on-confirm="confirmRoleModal()">
      <div style="width:100%; box-sizing:border-box; padding:10px 40px;">
        <ul class="allUL">
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>角色名称</span>
            <input maxlength="50" v-model="roleModalData.name" type="text" class="allInput" style="width: calc(100% - 110px); margin-left: -30px;" placeholder="请输入名称" />
          </li>
        </ul>
      </div>
    </model>
  </div>
</template>

<script>
export default {
  name: 'authorityList',
  data () {
    return {
      roleMenu: [],
      userInfo: JSON.parse(window.sessionStorage.getItem('userInfo')),
      groupFlag: false,
      userList: [],
      selectIndex: 0,
      userSelectIndex: '',
      showUserPicker: false,
      // allGroupsList: [],
      allNewAdmins: [],
      menuList: JSON.parse(window.localStorage.getItem('menuList')),
      totalmenuList: JSON.parse(window.localStorage.getItem('menuList')), // 菜单权限
      orginMenuList: [],
      treeOperationList: [], // 操作权限
      showRoleModal: false,
      roleModalTitle: '添加角色',
      roleModalData: {
        id: 0,
        name: ''
      }
    }
  },
  created () {
    // this.getAllGroups()
    this.getAllmenu()
  },
  methods: {
    async inportUser (e) {
      console.log(e)
      if (e.target.value !== '') {
        let file = document.getElementById('userFile').files[0]
        e.target.value = ''
        let res = await this.$commonJs.uploadUser(file)
        console.log(res)
        if (res) {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '导入成功',
            stayTime: 5
          })
        }
      }
    },
    async inportUser2 (e) {
      if (e.target.value !== '') {
        let file = document.getElementById('userFile2').files[0]
        e.target.value = ''
        let res = await this.$commonJs.uploadUser2(file)
        if (res) {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '导入成功',
            stayTime: 5
          })
        }
      }
    },
    getAllmenu () {
      this.$axiox.get('/api/authoritymenu/GetAllMenus/menus').then(p => {
        console.log(p, 'p---------------00000000')
        for (let i = 0; i < p.length; i++) {
          p[i].showMenu = true
          if (i === 0) {
            p[i].active = 'contenListCommentListContentReleasecommentListMaterialLibraryeditContListContentReleaseListproductList'
            p[i].iconName = 'icon iconfont iconneirong'
          }
          if (i === 1) {
            p[i].active = 'userListwhiteList'
            p[i].iconName = 'icon iconfont iconyingyongguanli'
          }
          if (i === 2) {
            p[i].active = ''
            p[i].iconName = 'icon iconfont iconwendangguanlixitong-shujuzhongxintubiao'
          }
          if (i === 3) {
            p[i].active = 'AllauthorityList'
            p[i].iconName = 'icon iconfont iconquanxian1'
          }
          // for (let j = 0; j < p[i].tabMenus.length; j++) {
          //   if (p[i].tabMenus[j].menuName === 'HCP列表' || p[i].tabMenus[j].menuName === '统计报表') {
          //     p[i].tabMenus[j].buttonMenus = p[i].buttonMenus
          //   }
          // }
        }
        this.totalmenuList = p
        console.log(this.totalmenuList, '菜单权限')
        this.getAllRoles()
      })
    },
    getAllRoles () {
      this.$axiox.get('/api/employeerole/Gets?pageIndex=1&pageSize=9999').then(p => {
        this.roleMenu = p
        this.selectRoles(0)
      })
    },
    editGroupsConfirm () {
      let groupIdList = []
      // for (let i = 0; i < this.allGroupsList.length; i++) {
      //   if (this.allGroupsList[i].checked) {
      //     groupIdList.push(this.allGroupsList[i].id)
      //   }
      // }
      for (let i = 0; i < this.totalmenuList.length; i++) {
        if (this.totalmenuList[i].isSelected) {
          groupIdList.push(this.totalmenuList[i].id)
        }
        for (let j = 0; j < this.totalmenuList[i].tabMenus.length; j++) {
          if (this.totalmenuList[i].tabMenus[j].isSelected) {
            groupIdList.push(this.totalmenuList[i].tabMenus[j].id)
          }
        }
        for (let e = 0; e < this.totalmenuList[i].buttonMenus.length; e++) {
          if (this.totalmenuList[i].buttonMenus[e].isSelected) {
            groupIdList.push(this.totalmenuList[i].buttonMenus[e].id)
          }
        }
      }
      let data = {
        roleId: this.roleMenu[this.selectIndex].id,
        menuIds: groupIdList
      }
      this.$axiox.put('/api/authoritymenu/CreateRoleMenuMapping/CreateRoleMenuMapping', data).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '保存成功',
          stayTime: 5
        })
        this.groupFlag = false
        // setTimeout(p => {
        //   window.location.reload()
        // }, 10)
      })
    },
    returnEidtFlag (index) {
      this.groupFlag = false
      this.totalmenuList = JSON.parse(JSON.stringify(this.orginMenuList))
      // this.chooseGroup(index)
    },
    groupsEditMode () {
      this.groupFlag = true
      this.orginMenuList = JSON.parse(JSON.stringify(this.totalmenuList))
    },
    getAllGroups () {
      if (this.selectIndex === 1 || this.selectIndex === 2 || this.selectIndex === 0) {
        let data = {
          status: 1,
          pageIndex: 1,
          pageSize: 99999
        }
        let url = this.$commonJs.returnQuery('/api/contentType/all', data)
        this.$axiox.get(url).then(msg => {
          this.allGroupsList = msg.result.items
          for (let i = 0; i < this.allGroupsList.length; i++) {
            this.$set(this.allGroupsList[i], 'checked', false)
          }
        })
      } else {
        let data = {
          pageIndex: 1,
          pageSize: 99999
        }
        let url = this.$commonJs.returnQuery('/api/Group/group', data)
        this.$axiox.get(url).then(msg => {
          this.allGroupsList = msg.result.items
          for (let i = 0; i < this.allGroupsList.length; i++) {
            this.$set(this.allGroupsList[i], 'checked', false)
          }
        })
      }
    },
    selectRoles (index) {
      this.selectIndex = index
      this.userSelectIndex = ''
      // this.$axiox.get('/api/authoritymenu/GetAllMenusByRole/rolemenus?roleId=' + this.roleMenu[this.selectIndex].id).then(msg => {
      this.$axiox.get('/api/authoritymenu/GetAllMenusSelectedByRole/RoleSelectedMenus?roleId=' + this.roleMenu[this.selectIndex].id).then(msg => {
        console.log(msg)
        this.menuList = msg
        this.totalmenuList = msg
        // for (let i = 0; i < this.totalmenuList.length; i++) {
        //   this.$set(this.totalmenuList[i], 'checked', false)
        //   for (let j = 0; j < this.menuList.length; j++) {
        //     if (this.totalmenuList[i].id === this.menuList[j].id) {
        //       this.$set(this.totalmenuList[i], 'checked', true)
        //     }
        //   }
        // }
        // if (this.selectIndex === 1 || this.selectIndex === 2 || this.selectIndex === 3) {
        // this.getAllGroups()
        // }
      })
      this.$axiox.getList('/api/employeerole/GetEmps?roleId=' + this.roleMenu[this.selectIndex].id + '&PageSize=9999&PageIndex=1').then(msg => {
        this.userList = msg.data
        for (let i = 0; i < this.userList.length; i++) {
          this.$set(this.userList[i], 'checked', false)
        }
        // if (this.selectIndex === 1 || this.selectIndex === 2 || this.selectIndex === 3) {
        // this.getAllGroups()
        // }
        this.groupFlag = false
      })
    },
    searchUser (e) {
      console.log(e.target.value)
      let domList = document.querySelectorAll('.userList')
      if (domList) {
        for (let i = 0; i < domList.length; i++) {
          if (this.userList[i].email.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0 || this.userList[i].chineseName.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0) {
            console.log(1)
            domList[i].style.display = 'inline-block'
          } else {
            console.log(2)
            domList[i].style.display = 'none'
          }
        }
      }
    },
    addNewUser () {
      this.showUserPicker = true
    },
    confirUserPicker (e) {
      console.log(e)
      setTimeout(p => {
        this.selectRoles(this.selectIndex)
      }, 2000)
      let data = e.chooseUserIdList
      // let data = {
      //   role: this.roleMenu[this.selectIndex].replace(' ', ''),
      //   userIds: e.chooseUserIdList
      // }
      this.$axiox.post('/api/employeerole/RoleAddUser?roleId=' + this.roleMenu[this.selectIndex].id, data).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '添加成功',
          stayTime: 5
        })
        this.selectRoles(this.selectIndex)
      })
    },
    chooseGroup (index) {
      // console.log(this.allGroupsList)
      this.userSelectIndex = index
      // for (let i = 0; i < this.allGroupsList.length; i++) {
      //   this.$set(this.allGroupsList[i], 'checked', false)
      // }
      this.groupFlag = false
      if (this.selectIndex === 1 || this.selectIndex === 0) {
        this.$axiox.post('/api/authoritymenu/GetAllMenusByUser/usermenus', {userId: this.userList[index].id}).then(msg => {
          // for (let i = 0; i < this.allGroupsList.length; i++) {
          //   let flag = false
          //   this.$set(this.allGroupsList[i], 'checked', false)
          //   for (let j = 0; j < msg.result.editorTypes.length; j++) {
          //     if (this.allGroupsList[i].typeName === msg.result.editorTypes[j].typeName) {
          //       flag = true
          //     }
          //   }
          //   if (flag) {
          //     this.allGroupsList[i].checked = true
          //   }
          // }
          for (let i = 0; i < this.menuList.length; i++) {
            let flag = false
            this.$set(this.menuList[i], 'checked', false)
            for (let j = 0; j < msg.result.editorTypes.length; j++) {
              if (this.menuList[i].name === msg.result.editorTypes[j].typeName) {
                flag = true
              }
            }
            if (flag) {
              this.menuList[i].checked = true
            }
          }
        })
      }
      if (this.selectIndex === 2) {
        this.$axiox.get('/api/contentType/fromuser/' + this.userList[index].userId).then(msg => {
          for (let i = 0; i < this.allGroupsList.length; i++) {
            let flag = false
            this.$set(this.allGroupsList[i], 'checked', false)
            for (let j = 0; j < msg.result.ownerTypes.length; j++) {
              if (this.allGroupsList[i].typeName === msg.result.ownerTypes[j].typeName) {
                flag = true
              }
            }
            if (flag) {
              this.allGroupsList[i].checked = true
            }
          }
        })
      }
      if (this.selectIndex === 3) {
        for (let i = 0; i < this.allGroupsList.length; i++) {
          let flag = false
          this.$set(this.allGroupsList[i], 'checked', false)
          let adminsList = this.allGroupsList[i].admins.split(',')
          console.log(adminsList)
          for (let j = 0; j < adminsList.length; j++) {
            if (this.userList[this.userSelectIndex].userName === adminsList[j]) {
              flag = true
            }
          }
          if (flag) {
            this.allGroupsList[i].checked = true
          }
        }
      }
    },
    removeSelectUser (index) {
      this.$commonJs.doubleComfirm({
        content: '确定删除此用户？',
        successFun: msg => {
          let data = [this.userList[index].empRoleRuleId]
          this.$axiox.post('/api/employeerole/RoleRemoveUser', data).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.userList.splice(index, 1)
            this.userSelectIndex = ''
          })
        },
        errorFun: msg => {
        }
      })
    },
    setExpandHandler (arr) {
      arr.forEach(val => {
        val.expand = false
      })
    },
    addNewRole () {
      this.showRoleModal = true
    },
    confirmRoleModal () {
      if (this.roleModalData.id === 0) {
        // 添加
        if (this.roleModalData.name) {
          for (let i = 0; i < this.roleMenu.length; i++) {
            if (this.roleMenu[i].role === this.roleModalData.name) {
              this.$commonJs.alertTips({
                type: 'error',
                title: '错误',
                content: '角色名重复',
                stayTime: 5
              })
              return
            }
          }
          this.$axiox.post(`/api/employeerole/Add?role=${this.roleModalData.name}&introduce=${this.roleModalData.name}`).then(res => {
            console.log(res, '添加')
            this.getAllRoles()
            this.showRoleModal = false
            this.roleModalData.name = ''
            this.roleModalData.id = 0
          })
        } else {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请检查必填项',
            stayTime: 5
          })
        }
      } else {
        // 编辑
        if (this.roleModalData.name) {
          this.$axiox.post(`/api/employeerole/Update?id=${this.roleModalData.id}&role=${this.roleModalData.name}&introduce=${this.roleModalData.name}`).then(res => {
            console.log(res, '编辑')
            this.getAllRoles()
            this.showRoleModal = false
            this.roleModalData.name = ''
            this.roleModalData.id = 0
          })
        } else {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请检查必填项',
            stayTime: 5
          })
        }
      }
    },
    cancelRoleModal () {
      this.showRoleModal = false
      this.roleModalData.name = ''
      this.roleModalData.id = 0
    },
    updateRole (item) {
      this.roleModalTitle = '编辑角色'
      this.showRoleModal = true
      this.roleModalData.name = item.role
      this.roleModalData.id = item.id
    },
    deleteRole (item) {
      this.$commonJs.doubleComfirm({
        content: '您是否确认删除？',
        successFun: msg => {
          this.$axiox.get(`/api/employeerole/Delete?id=${item.id}`).then(res => {
            console.log(res, '删除')
            this.getAllRoles()
          })
        },
        errorFun: msg => {
        }
      })
    },
    // 父级
    changeFather (type) {
      let flag = true
      if (!type.isSelected) {
        flag = false
      }
      if (type.tabMenus && type.tabMenus.length > 0) {
        for (let i = 0; i < type.tabMenus.length; i++) {
          if (flag) {
            type.tabMenus[i].isSelected = true
          } else {
            type.tabMenus[i].isSelected = false
          }
        }
      }
      // if (type.buttonMenus && type.buttonMenus.length > 0) {
      //   for (let i = 0; i < type.buttonMenus.length; i++) {
      //     if (flag) {
      //       type.buttonMenus[i].isSelected = true
      //     } else {
      //       type.buttonMenus[i].isSelected = false
      //     }
      //   }
      // }
    },
    // 子集全选
    checkIfGetAll (item, tabItem) {
      for (let i = 0; i < this.totalmenuList.length; i++) {
        let checknum = 0
        if (this.totalmenuList[i].tabMenus && this.totalmenuList[i].tabMenus.length > 0) {
          for (let j = 0; j < this.totalmenuList[i].tabMenus.length; j++) {
            if (this.totalmenuList[i].tabMenus[j].isSelected) {
              checknum++
            }
          }
          if (checknum === 0) {
            this.totalmenuList[i].isSelected = false
          } else {
            this.totalmenuList[i].isSelected = true
          }
        }
      }
    },
    clickBt () {
    }
  }
}
</script>

<style scoped>
  .horSpan span.activeUser{
    background-color: #ee1100;
    color: #fff;
  }
  .addSubmenu{
    padding:5px 10px;
    margin: 0 10px;
    border-color: #ee1100;
    border-radius: 4px;
    color:#ee1100;
  }
  .cancelButtonTwo{
    border-color: #ee1100;
    color:#ee1100;
  }
  .authorityNav{
    padding: 10px;
    color: #8C8C8C;
    font-size: 16px;
  }
  .authorityBody{
    min-height: 750px;
  }
  .authorityBody > div{
  display: inline-block;
  vertical-align: top;
  }
  .authorityleft{
    width: calc(20% - 10px);
  }
  .authorityleft > div{
    max-height: 600px;
    overflow: auto;
  }
  .authorityleft > div ul {
    padding:10px;
  }
  .authorityleft > div ul li{
    text-align: center;
    padding: 10px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .onClickli{
    background-color: #ee1100;
    color: white;
    border-radius: 4px;
  }
  .redButton{
    color: #ee1100;
    background-color: #ee1100;
  }
  .redButtonTwo{
    background-color: #ee1100;
    border-radius: 4px;
  }
  .authorityCent{
    width: calc(20% - 10px);
    background-color: #FAFAFA;
    min-height: 580px;
  }
  .authorityCentTwo{
    width: 80%;
    background-color: #FAFAFA;
    min-height: 750px;
  }
  .authorityRight{
    width: 60%;
  }
  .horSpan{
    white-space: normal;
    overflow: auto;
    padding: 10px;
    width: calc(100% - 20px);
    max-height: 600px;
  }
  .allTable td{
    padding: 10px;
    /*padding-left: 50px !important;*/
  }
  .allTable th{
    border-bottom-color: #ee1100;
    padding: 10px;
    /*padding-left: 50px !important;*/
  }
  .horSpan span{
    display: inline-block;
    padding: 10px 15px;
    background-color: #EFEFEF;
    border-radius: 4px;
    cursor: pointer;
    margin: 5px;
    white-space: nowrap;
  }
  .delSpan{
    width: calc(100% - 20px);
    padding:10px 5px!important;
  }
  @media screen and (max-width: 1370px) {
    .onlyInput {
      padding: 5px 15px !important;
      width: calc(100% - 20px) !important;
    }
    .alldw {
      top: 25%!important;
      right: 0px!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/permissionManger/authorityList.vue